import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayorFacilitiesComponent } from './payor-facilities.component';
import {AgGridModule} from 'ag-grid-angular';
import {PayorFacilitiesService} from './payor-facilities.service';
import {DirectivesModule} from '../../../directives/directives.module';
import {AutoCompleteFacilitiesModule} from '../../A2-utils/auto-complete-facilities/auto-complete-facilities.module';

@NgModule({
  imports: [
    CommonModule,
    AgGridModule.withComponents([]),
    DirectivesModule,
    AutoCompleteFacilitiesModule
  ],
  declarations: [PayorFacilitiesComponent],
  exports: [
    PayorFacilitiesComponent
  ],
  providers: [
    PayorFacilitiesService
  ]
})
export class PayorFacilitiesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/payors/payor-facilities/payor-facilities.module.ts